// Stylesheets
import './assets/scss/site.scss';

// SVG
// import './assets/svgs/facebook.svg';
// import './assets/svgs/instagram.svg';
// import './assets/svgs/mark.svg';
// import './assets/svgs/note.svg';
// import './assets/svgs/text-yambaru.svg';
// import './assets/svgs/title-horizontal-en.svg';
// import './assets/svgs/title-horizontal-ja.svg';
// import './assets/svgs/title.svg';
// import './assets/svgs/twitter.svg';

import 'jquery.easing';
import './assets/modules/vendor/jquery.mousewheel';
import './assets/modules/vendor/jquery.debouncedresize';
import './assets/modules/vendor/jquery.debouncedscroll';
import {Pjax} from 'pjax-api';
import {fixSvgIntrinsicSizing} from './assets/modules/vendor/fixSvgIntrinsicSizing';
import {initPhotoSwipeFromDOM} from './assets/modules/photoswipe-init';
import {scrollPageTop} from './assets/modules/scrollPageTop';
import {animateCancel} from './assets/modules/animateCancel';
import {hover} from './assets/modules/hover';
import {lazyload} from './assets/modules/lazyload';
import {stickyHeader} from './assets/modules/stickyHeader';
import {headerNestNav} from './assets/modules/headerNestNav';
import {headerSpNav} from './assets/modules/headerSpNav';
import {shareButton} from './assets/modules/shareButton';
import {openToday} from './assets/modules/openToday';
import {localNav} from './assets/modules/localNav';
import {localNavInboundScroll} from './assets/modules/localNavInboundScroll';
import {heroCarousel} from './assets/modules/heroCarousel';
import {imageGallery} from './assets/modules/imageGallery';
import {artistTrigger} from './assets/modules/artistTrigger';
import {popupVideo} from './assets/modules/popupVideo';
import {calender} from './assets/modules/calender';

const init = () => {
  fixSvgIntrinsicSizing();
  hover();
  initPhotoSwipeFromDOM('.js-photoswipe-gallery');
  lazyload();
  headerNestNav();
  stickyHeader();
  localNav();
  localNavInboundScroll();
  heroCarousel();
  imageGallery();
  artistTrigger();
  popupVideo();
  calender();
  openToday();
}

$(function() {
  init();
  scrollPageTop();
  animateCancel();
  headerSpNav();
  shareButton();
});

new Pjax({
  areas: [
    '#header-nav, #header-lang-nav, #container',
    'body'
  ],
  update: {
    css: false,
    script: false
  }
});
 
document.addEventListener('pjax:ready', function(e) {
  if ($('#container').hasClass('is-home')) {
    $('#header').addClass('is-home');
  } else {
    $('#header').removeClass('is-home');
  }
  $('body,html').stop();
  $('#header-nav-container').removeClass('is-show-sp');
  $('#header-sp-trigger').removeClass('is-sp-nav-active');
  $('#header-sp-overlay').removeClass('is-sp-nav-active');
  $(document.body).removeClass('is-sp-nav-active');
  init();
  gtag('config', ga_code, {'page_path' : location.pathname});
});